/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * カスタム計算条件の保存レスポンス
 * @export
 * @interface CustomCalcConditionResponse
 */
export interface CustomCalcConditionResponse {
    /**
     * 保存されたファイル名
     * @type {string}
     * @memberof CustomCalcConditionResponse
     */
    filename: string;
}

/**
 * Check if a given object implements the CustomCalcConditionResponse interface.
 */
export function instanceOfCustomCalcConditionResponse(value: object): value is CustomCalcConditionResponse {
    if (!('filename' in value) || value['filename'] === undefined) return false;
    return true;
}

export function CustomCalcConditionResponseFromJSON(json: any): CustomCalcConditionResponse {
    return CustomCalcConditionResponseFromJSONTyped(json, false);
}

export function CustomCalcConditionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomCalcConditionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
    };
}

export function CustomCalcConditionResponseToJSON(json: any): CustomCalcConditionResponse {
    return CustomCalcConditionResponseToJSONTyped(json, false);
}

export function CustomCalcConditionResponseToJSONTyped(value?: CustomCalcConditionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
    };
}

